import { Flex } from "antd";
import { useEffect, useMemo, useState } from "react";
import Filters from "../../components/Filters";
import { useAuth } from "../../context/AuthContext";
import useCollectionsZoneTimelineV2 from "../../hooks/useCollectionsZoneTimelineV2";
import CollectionsTimeLineWrapper from "./CollectionsTimeLineWrapper";
import TableEventsWrapper from "./TableEventsWrapper";
import { periodoSemiaberto } from "./promoHelpers";
import { opcoesDaTimeline } from "./timelineDaV2";

export default function CollectionsChangeRefact() {
  const { user } = useAuth();
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [selectedZones, setSelectedZones] = useState(["all"]);
  const [selectedCollections, setSelectedCollections] = useState(["all"]);
  const [selectedAnalysisDays, setSelectedAnalysisDays] = useState(7);
  const [selectedBaseline, setSelectedBaseline] = useState(null);

  useEffect(() => {
    setSelectedZones(["all"]);
    setSelectedCollections(["all"]);
    setSelectedAnalysisDays(7);
    setSelectedBaseline(null);
  }, [user?.active_branch_id]);

  useEffect(() => {
    setSelectedCollections(["all"]);
  }, [selectedZones]);

  const periodo = useMemo(
    () => periodoSemiaberto(selectedDateRange),
    [selectedDateRange]
  );
  const timeline = useCollectionsZoneTimelineV2({
    branchId: user?.active_branch_id ?? null,
    start: periodo?.start,
    end: periodo?.end,
  });
  const linhasDaTimeline = timeline.data?.linhas;

  const collectionsOptions = useMemo(
    () => opcoesDaTimeline(linhasDaTimeline, selectedZones),
    [linhasDaTimeline, selectedZones]
  );

  return (
    <Flex
      vertical
      gap={50}
      justify="center"
      align="center"
      style={{ width: "100%", margin: "0 auto" }}>
      <Filters
        page="collections_change"
        dateRange={true}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        selectedCollections={selectedCollections}
        setSelectedCollections={setSelectedCollections}
        selectedAnalysisDays={selectedAnalysisDays}
        setSelectedAnalysisDays={setSelectedAnalysisDays}
        selectedBaseline={selectedBaseline}
        setSelectedBaseline={setSelectedBaseline}
        filters={["data", "zonas", "colecoes", "dias_analise"]}
        collectionsOptions={collectionsOptions}
      />
      <CollectionsTimeLineWrapper
        linhas={linhasDaTimeline}
        isLoading={timeline.isLoading && Boolean(periodo)}
        error={timeline.error}
        selectedZones={selectedZones}
        selectedCollections={selectedCollections}
        selectedDateRange={selectedDateRange}
      />
      {selectedDateRange?.[0] && selectedDateRange?.[1] && (
        <TableEventsWrapper
          selectedDateRange={selectedDateRange}
          zones={selectedZones}
          selectedCollections={selectedCollections}
          collectionsOptions={collectionsOptions}
          period={selectedAnalysisDays}
          baseline={selectedBaseline}
        />
      )}
    </Flex>
  );
}
